import { useEffect, useState } from "react";
import BasicWrapper from "../../components/basicWrapper/basicWrapper";
import ExtendedWrapper from "../../components/extendedWrapper/extendedWrapper";
import { IvnoiceContextProvider } from "../createInvoice/createInvoiceContext";

import { useToaster, Notification, Message } from "rsuite";

import "../createInvoice/steps/createInvoice.css"
//
import InvoiceMain from "../createInvoice/steps/1_invoiceMain";
import InvoiceTariff from "../createInvoice/steps/2_tariffPanel";
import InvoiceAdditions from "../createInvoice/steps/3_invoiceAdditions";
import InvoiceDelivery from "../createInvoice/steps/4_invoiceDelivery";
import InvoiceCalculation from "../createInvoice/steps/5_invoiceCalculation";
import InvoiceResult from "../createInvoice/steps/6_resultPanel";

import InputVoice from "../../components/inputVoice/InputVoice";

import validateForm from "./steps/validators/validatorHelper";
import applyVoice from "../createInvoice/steps/utils/applyVoice";

import { useInvoiceContext } from "../createInvoice/createInvoiceContext";
import { useMessenger } from "../../context/messengerContext";

export default function CreateTemplateWrapperExtended({
    invoiceStep, setInvoiceStep,
    maxStep, setMaxStep, setSkip
}) {
    const { invoiceData, setInvoiceData, templates } = useInvoiceContext();
    const [startTime, setStartTime] = useState(new Date());
    const [ voiceData, setVoiceData ] = useState({});

    const [refresh, setRefresh] = useState(0);

    const { userId, platform } = useMessenger();

    const toaster = useToaster();

    useEffect(() => {
        // total calculated weight
        let calculated_weight = invoiceData.places.reduce((sum, place) => sum + place.weight, 0);

        if (invoiceStep === 1 && (!calculated_weight || !invoiceData.cityFrom || !invoiceData.cityTo)) {
            console.log(invoiceStep, calculated_weight, invoiceData.cityFrom, invoiceData.cityTo);
            setInvoiceStep(2);
            setSkip(true);
        } else if (calculated_weight && invoiceData.cityFrom && invoiceData.cityTo) {
            setSkip(false);
        }
    }, [invoiceStep])

    useEffect(() => {
        console.log(voiceData)
        if (!voiceData || !Object.keys(voiceData).length) return;
        setInvoiceData(d => applyVoice(d, voiceData));
        setRefresh(r => r + 1);
    }, [voiceData]);

    return (
        <>
            <ExtendedWrapper>
                {   
                    invoiceStep === 0 && <InvoiceMain isTemplate /> ||
                    invoiceStep === 1 && <InvoiceTariff /> ||
                    invoiceStep === 2 && <InvoiceAdditions /> ||
                    invoiceStep === 3 && <InvoiceDelivery isTemplate /> ||
                    invoiceStep === 4 && <InvoiceCalculation /> ||
                    invoiceStep === 5 && <InvoiceResult startTime={startTime} isTemplate />
                }
                {
                    invoiceStep != 5 ?
                    <InputVoice onNavigateForward={() => {
                        let errors = validateForm(invoiceStep, invoiceData, templates)
                        
                        setInvoiceData({...invoiceData, errors});
                        console.log(errors);
                        if (Object.keys(errors).length) {
                            // Show specific template name error if it exists, otherwise show generic error
                            const errorMessage = errors.template_name && errors.template_name !== 'template_name_error' 
                                ? errors.template_name 
                                : "Заполнены не все обязательные поля";
                            toaster.push(<Message type="error" showIcon>{errorMessage}</Message>, { placement: "topCenter", duration: 3000 });
                            return;
                        };

                        setInvoiceStep(Math.min(5, invoiceStep + 1));
                    }} ml_page={"prepare_invoice_calculate"} setJsonForm={setVoiceData}/>
                    : null
                }
            </ExtendedWrapper>
        </>
    )
}